var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0511 21.7002L21.5196 21.1146H21.5196L21.0511 21.7002ZM18.2236 19.4383L18.6921 18.8526L18.2236 19.4383ZM21.9258 8C21.9258 5.65279 20.023 3.75 17.6758 3.75V2.25C20.8514 2.25 23.4258 4.82436 23.4258 8H21.9258ZM21.9258 13.5V8H23.4258V13.5H21.9258ZM21.9258 14V13.5H23.4258V14H21.9258ZM21.9258 20.9194V14H23.4258V20.9194H21.9258ZM21.5196 21.1146C21.6833 21.2455 21.9258 21.129 21.9258 20.9194H23.4258C23.4258 22.3868 21.7284 23.2026 20.5826 22.2859L21.5196 21.1146ZM18.6921 18.8526L21.5196 21.1146L20.5826 22.2859L17.7551 20.0239L18.6921 18.8526ZM7.67578 18.25H16.9742V19.75H7.67578V18.25ZM3.42578 14C3.42578 16.3472 5.32857 18.25 7.67578 18.25V19.75C4.50014 19.75 1.92578 17.1756 1.92578 14H3.42578ZM3.42578 8V14H1.92578V8H3.42578ZM7.67578 3.75C5.32857 3.75 3.42578 5.65279 3.42578 8H1.92578C1.92578 4.82436 4.50014 2.25 7.67578 2.25V3.75ZM17.6758 3.75L7.67578 3.75V2.25L17.6758 2.25V3.75ZM17.7551 20.0239C17.5334 19.8466 17.2581 19.75 16.9742 19.75V18.25C17.5987 18.25 18.2045 18.4625 18.6921 18.8526L17.7551 20.0239Z",
    fill: "#0D4740"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "matrix(-1 0 0 1 18.875 9.80078)",
    fill: "#0D4740"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "matrix(-1 0 0 1 13.875 9.80078)",
    fill: "#0D4740"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "matrix(-1 0 0 1 8.875 9.80078)",
    fill: "#0D4740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.bcfc83af283cd896867ab652a108a19d.svg";
export { ForwardRef as ReactComponent };